import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "night",
  "use": "night-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"night\"><path fill-rule=\"evenodd\" d=\"M7 5a8 8 0 0 0 10.576 7.576A8.002 8.002 0 0 1 2 10a8.003 8.003 0 0 1 5.424-7.576A7.974 7.974 0 0 0 7 5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol